import React from "react";
import { connect } from "react-redux";
import CrewMember from "../b5-home/CrewMember.js";

class RallyCombatantsList extends React.Component {

  //Provide a Mystery Man as the "INVITE" spot
  renderInvitePlaceholderCombatant() {

    if (this.props.combatantsList.length >= 6) {
      return null;
    }

    const displayPosition = this.props.combatantsList.length+1;

    return (
      <CrewMember
        isRallyInviter={true}
        isReady={false}
        combatantId={"none"}
        showLaptop={false}
        position={displayPosition}
        isEvenPositionMode={true}
        evenPositionRowNumber={displayPosition > 3 ? 2 : 1} //Row 2 or Row 1
        memberId={"none"}
        name={""}
        skinId={"skin_mystery"}
        isBot={false}
        canShowBotRemoveButton={false}
        loadoutTitle={"Position"}
        isEditable={false}
      />
    );
  }

  //Provide a List of combatants displayed in Rally formation
  render() {
    const style = {
      position: "relative",
      height: "40em" //Tall enough for two rows of combatants
    };
    return (
      <div style={style}>
        {this.props.combatantsList.map((combatant, i) => {

          const rawId = combatant._id.replace("client_", "");

          const displayPosition = i + 1;
          return (
            <CrewMember
              key={i}
              isReady={Boolean(this.props.roomReadyClients[rawId])}
              combatantId={combatant._id}
              showLaptop={true}
              position={displayPosition}
              isEvenPositionMode={true}
              evenPositionRowNumber={displayPosition > 3 ? 2 : 1} //Row 2 or Row 1
              memberId={combatant.memberId}
              name={combatant.name}
              skinId={combatant.skinId}
              isBot={combatant.isBot}
              canShowBotRemoveButton={this.props.isMaster /*Only allowed to show this if you're admin*/}
              loadoutTitle={combatant.loadoutTitle}
              isEditable={this.props.playerRallyCombatantId === combatant._id}
            />
          );
        })}
        {this.renderInvitePlaceholderCombatant()}
      </div>
    );
  }
}
export default connect((state, props) => {
  return {
    //someProp: state.something.someProp
    roomReadyClients: state.matchmaking.readyClients,
    playerRallyCombatantId: state.battle.battlePlayerId[0],

  };
})(RallyCombatantsList);



// WEBPACK FOOTER //
// ./src/battle/RallyCombatantsList.js